module.exports = __webpack_public_path__ + "static/img/term_library_delete_batch.922e7db7.gif";